import { useEffect, useRef } from "react";
import Cookies from "universal-cookie";
import Auth from "../Auth";
import { chooseRandom } from "../Utils";
import useMediaQuery from "./useMediaQuery";
import { detect } from "detect-browser";
const browser = detect();

export default ({ clientId, key, variations, mediaQuery = "", ignoredBrowsers = [] }) => {
  const variationId = useRef(null);
  const active = useRef(false); // whether the test is actually active
  const mediaQueryPasses = mediaQuery ? useMediaQuery(mediaQuery) : true; // Media conditions for conditional activation
  const browserPasses = !ignoredBrowsers.includes(browser?.name);
  const allChecksPass = mediaQueryPasses && browserPasses;

  useEffect(() => {
    if (!allChecksPass) return;
    try {
      const cookies = new Cookies();
      // check cookies
      let id = cookies.get(`test_${key}`);

      if (!id) {
        id = chooseRandom(variations);

        cookies.set(`test_${key}`, id, {
          maxAge: 60 * 60 * 24 * 365 * 4,
          path: "/",
        });
      }

      variationId.current = id;

      active.current = true;
      console.log(`[TEST] variation for '${key}':`, variationId.current);
    } catch (e) {
      // in case it fails, we just choose the first variation

      variationId.current = variations[0];
      console.log(`[TEST] '${key}' failed! setting to first variation:`, variationId.current);
    }
  }, []);

  useEffect(() => {
    if (clientId && variationId.current && active.current && allChecksPass) {
      console.log("Experiment triggered", mediaQueryPasses);
      Auth.fetchWithIdToken("/api/test/experimentViewed", {
        experiment_id: key,
        variation_id: variationId.current,
        anonymous_id: clientId,
      }).then((result) => {});
    }
  }, [clientId, variationId.current]);

  return [variationId.current];
};
